import { render, staticRenderFns } from "./recentLogistics.vue?vue&type=template&id=7209a020&scoped=true&"
import script from "./recentLogistics.vue?vue&type=script&lang=js&"
export * from "./recentLogistics.vue?vue&type=script&lang=js&"
import style0 from "./recentLogistics.vue?vue&type=style&index=0&id=7209a020&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7209a020",
  null
  
)

export default component.exports